// The dot grid on the Journey Card: small dots that fade out from the top right corner towards the middle and the
// left of the card. Drawn as inline SVG with the opacity on each dot, since html2canvas does not draw CSS mask-image
// when the card is captured as an image.
const OPACITY = 0.16;
// The radial fade from the "JourneyCard-Curve-B" board, from the top right corner: full, 75 % after a third,
// 30 % after two thirds, and gone at the far edge.
const FADE: [number, number][] = [
  [0, 1],
  [0.35, 0.75],
  [0.65, 0.3],
  [1, 0],
];

const fade = (distance: number) => {
  for (let i = 1; i < FADE.length; i++) {
    const [d0, f0] = FADE[i - 1];
    const [d1, f1] = FADE[i];
    if (distance <= d1) return f0 + ((distance - d0) / (d1 - d0)) * (f1 - f0);
  }
  return 0;
};

const makeDots = (width: number, height: number, gap: number) => {
  const columns = Math.floor(width / gap);
  const rows = Math.floor(height / gap);
  return Array.from({ length: columns * rows }, (_, i) => {
    const cx = (i % columns) * gap + gap / 2;
    const cy = Math.floor(i / columns) * gap + gap / 2;
    // Elliptical: the same share of the width and of the height counts the same.
    const distance = Math.hypot((width - cx) / width, cy / height);
    return { cx, cy, opacity: Number((OPACITY * fade(distance)).toFixed(3)) };
  }).filter((dot) => dot.opacity > 0);
};

type DotPatternProps = {
  color: string;
  className?: string;
  width?: number;
  height?: number;
  gap?: number;
  radius?: number;
};

const DotPattern = ({ color, className, width = 420, height = 260, gap = 28, radius = 2 }: DotPatternProps) => (
  <svg data-testid='dot-pattern' aria-hidden='true' className={className} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
    {makeDots(width, height, gap).map(({ cx, cy, opacity }) => (
      <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={radius} fill={color} fillOpacity={opacity} />
    ))}
  </svg>
);

export default DotPattern;
